export const MOODS = [
  { key: "food", label: "Food & Drink", emoji: "🍽️", query: { category: "Food & Drink" } },
  { key: "date-night", label: "Date Night", emoji: "💛", query: { tag: "date-night" } },
  { key: "family-fun", label: "Family Fun", query: { tag: "family-fun" } },
  { key: "outdoors", label: "Outdoors", query: { category: "Outdoors" } },
  { key: "sports", label: "Sports", query: { category: "Sports" } },
  { key: "fitness", label: "Fitness", query: { category: "Fitness" } },
  { key: "live-music", label: "Live Music", query: { tag: "live-music" } },
  { key: "quiet", label: "Quiet", query: { tag: "quiet" } },
  { key: "equestrian", label: "Equestrian", query: { category: "Equestrian" } },
  { key: "something-new", label: "Something New", query: { featured: "true" } },
];

export const CATEGORIES = [
  "Food & Drink", "Entertainment", "Attractions", "Outdoors",
  "Sports", "Fitness", "Equestrian", "Arts & Culture", "Church", "Shopping", "Family",
];

// Specific sports usable as tags, combinable with the "Sports" category.
export const SPORTS_TAGS = [
  "Golf", "Baseball", "Tennis", "Soccer", "Basketball", "Pickleball", "Disc Golf",
];

// Fitness sub-types usable as tags, combinable with the "Fitness" category.
export const FITNESS_TAGS = [
  "Gym", "Yoga", "HIIT", "CrossFit", "Pilates", "Cycling",
];
